import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const useShowInvoice = () => {
  const MySwal = withReactContent(Swal);

  const showInvoice = (invoice) => {
    const productDetails = invoice.invoiceCategories
      ?.map(
        (item, index) => `
          <tr>
            <td class="border p-1 text-xs font-bold">${index + 1}</td>
            <td class="border p-1 text-xs font-bold">${item.category?.name || "N/A"}</td>
            <td class="border p-1 text-xs font-bold text-center">${item.quantity || "0"}</td>
            <td class="border p-1 text-xs font-bold text-center">${item.price || "0"}</td>
            <td class="border p-1 text-xs font-bold text-center">${item.total || "0"}</td>
          </tr>
        `
      )
      .join("");

    const formattedDate = new Date(invoice.invoiceDate).toLocaleDateString("ar-EG") || "N/A";

    MySwal.fire({
      title: `<h2 class="text-xl font-extrabold text-center mb-4 text-gray-800">فاتورة رقم: ${invoice.invoiceCode || "N/A"}</h2>`,
      html: `
        <div class="text-right text-sm">
          <div class="grid grid-cols-2 gap-4 mb-4">
            <div class="space-y-2">
              <p class="font-bold"><strong class="text-gray-700">اسم العميل:</strong> <span class="text-gray-800">${invoice.customer || "N/A"}</span></p>
              <p class="font-bold"><strong class="text-gray-700">العنوان:</strong> <span class="text-gray-800">${invoice.address || "N/A"}</span></p>
              <p class="font-bold"><strong class="text-gray-700">الهاتف:</strong> <span class="text-gray-800">${invoice.phone || "N/A"}</span></p>
              <p class="font-bold"><strong class="text-gray-700">الرقم الثاني:</strong> <span class="text-gray-800">${invoice.socendPhone || "N/A"}</span></p>
              <p class="font-bold"><strong class="text-gray-700">المحافظة:</strong> <span class="text-gray-800">${invoice.governorate?.name || "N/A"}</span></p>
              <p class="font-bold"><strong class="text-gray-700">الملاحظات:</strong> <span class="text-gray-800">${invoice.note || "N/A"}</span></p>
            </div>
            <div class="space-y-2">
              <p class="font-bold"><strong class="text-gray-700">تاريخ الفاتورة:</strong> <span class="text-gray-800">${formattedDate}</span></p>
              <p class="font-bold"><strong class="text-gray-700">السكرتير:</strong> <span class="text-gray-800">${invoice.userName || "N/A"}</span></p>
              <p class="font-bold"><strong class="text-gray-700">المندوب:</strong> <span class="text-gray-800">${invoice.representative?.fullName || "N/A"}</span></p>
              <p class="font-bold"><strong class="text-gray-700">حالة الفاتورة:</strong> <span class="text-gray-800">${invoice.status || "N/A"}</span></p>
              <p class="font-bold"><strong class="text-gray-700">سبب الحالة:</strong> <span class="text-gray-800">${invoice.statusCause || "N/A"}</span></p>
            </div>
          </div>

          <div class="mb-4">
            <table class="w-full border-collapse">
              <thead>
                <tr class="bg-gray-100">
                  <th class="border p-1 text-xs font-extrabold text-gray-700">#</th>
                  <th class="border p-1 text-xs font-extrabold text-gray-700">الصنف</th>
                  <th class="border p-1 text-xs font-extrabold text-gray-700 text-center">الكمية</th>
                  <th class="border p-1 text-xs font-extrabold text-gray-700 text-center">السعر</th>
                  <th class="border p-1 text-xs font-extrabold text-gray-700 text-center">الإجمالي</th>
                </tr>
              </thead>
              <tbody>
                ${productDetails || `<tr><td colspan="5" class="border p-1 text-center text-xs font-bold">لا توجد بيانات</td></tr>`}
              </tbody>
            </table>
          </div>

          <div class="mt-4">
            <table class="w-full border-collapse">
              <tbody>
                <tr class="bg-gray-50">
                  <td class="border p-1 text-xs font-extrabold text-gray-700">الاجمالي</td>
                  <td class="border p-1 text-xs font-extrabold text-gray-800 text-center">${invoice.totalPrice - invoice.shipping || 0}</td>
                </tr>
                <tr class="bg-gray-50">
                  <td class="border p-1 text-xs font-extrabold text-gray-700">الشحن</td>
                  <td class="border p-1 text-xs font-extrabold text-gray-800 text-center">${invoice.shipping || 0}</td>
                </tr>
                <tr class="bg-gray-100">
                  <td class="border p-1 text-xs font-extrabold text-gray-700">الاجمالي مع الشحن</td>
                  <td class="border p-1 text-xs font-extrabold text-gray-800 text-center">${invoice.totalPrice || 0}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      `,
      showCloseButton: true,
      focusConfirm: false,
      confirmButtonText: "إغلاق",
      confirmButtonClass: "bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-bold",
      customClass: {
        popup: "shadow-lg border-2 border-blue-600 rounded-lg max-w-3xl",
        title: "text-gray-800",
        htmlContainer: "text-gray-700",
      },
    });
  };

  return { showInvoice };
};

export default useShowInvoice;
